import { FC, ReactNode } from 'react'

import { useQuery } from '@tanstack/react-query'
import { getRouteApi } from '@tanstack/react-router'
import isEqual from 'lodash/isEqual'
import { adverseMediaListQueryOptions } from '~bank-adverse-media/service/adverseMediaListQueryOptions'
import { AdverseMediaListRequest } from '~bank-adverse-media/types'
import { adverseMediaListSchema } from '~bank-adverse-media/types/AdverseMediaListRequest'

import { AdverseMediaListContext } from './AdverseMediaListContext'

type AdverseMediaListProviderProps = {
  children: ReactNode
}

export const AdverseMediaListContextProvider: FC<AdverseMediaListProviderProps> = ({
  children
}: AdverseMediaListProviderProps) => {
  const routeApi = getRouteApi('/_app/adverse-media')

  const search = routeApi.useSearch()
  const navigate = routeApi.useNavigate()

  const clientUsersListQuery = useQuery(adverseMediaListQueryOptions(search))

  if (!clientUsersListQuery.data) return null

  const value = {
    data: clientUsersListQuery.data,
    isPending: clientUsersListQuery.isLoading || clientUsersListQuery.isRefetching,
    successFullyLoaded: !!clientUsersListQuery.data,
    state: { ...clientUsersListQuery.data?.form, ...search },
    redirect: navigate,
    navigate: (searchParams: Partial<AdverseMediaListRequest>) =>
      navigate({ to: '.', search: (prev) => ({ ...prev, ...searchParams }), resetScroll: false, replace: true }),
    clear: () => navigate({ to: '.', search: undefined, resetScroll: false, replace: true }),
    isFirstLoading: clientUsersListQuery.isLoading,
    isChanged: !isEqual(adverseMediaListSchema.parse({}), search)
  }

  return <AdverseMediaListContext.Provider value={value}>{children}</AdverseMediaListContext.Provider>
}
